import { useCallback } from 'react';
import { actions } from 'state';
import useThrottledCallback from './useThrottledCallback';

const useProductResultsView = ({
  dispatch,
  productsIsLoading,
  productsMeta,
  viewParams,
  withLenderId = false,
}: {
  dispatch: Function;
  productsIsLoading: boolean;
  productsMeta: { hasMore: boolean; total: number };
  viewParams?: { id?: string };
  withLenderId?: boolean;
}) => {
  const clearResults = useCallback(() => dispatch(actions.products.clearResults()), [dispatch]);
  const fetchProducts = useCallback(
    (filters: Record<string, unknown>, lenders: (string | number)[] = []) =>
      dispatch(actions.products.fetch(filters, lenders)),
    [dispatch]
  );
  const fetchMoreAction = useCallback(
    (lenders?: (string | number)[]) => dispatch(actions.products.fetchMore(lenders)),
    [dispatch]
  );
  const fetchMore = useThrottledCallback(fetchMoreAction);
  const lenderId = withLenderId ? viewParams?.id : null;

  const fetch = useCallback(
    (filters: Record<string, unknown>) => (lenderId ? fetchProducts(filters, [lenderId]) : fetchProducts(filters)),
    [fetchProducts, lenderId]
  );

  return {
    clearResults,
    fetch,
    fetchMore,
    hasMore: productsMeta.hasMore,
    isLoadingData: productsIsLoading,
    total: productsMeta.total,
  };
};

export default useProductResultsView;
